module.exports = __webpack_public_path__ + "static/img/meiyu.bff54457.png";